export function rem(px: number) {
  return `${px / 16}rem`
}

export const blogFontSize = {
  blogBody: {
    large: {
      fontSize: rem(22),
      lineHeight: rem(40),
    },
    medium: {
      fontSize: rem(18),
      lineHeight: rem(31),
    },
    small: {
      fontSize: rem(16),
      lineHeight: rem(28),
    },
  },
  blogHero: {
    large: {
      fontSize: rem(45),
      lineHeight: rem(52),
      letterSpacing: "-0.69%",
    },
    medium: {
      fontSize: rem(32),
      lineHeight: rem(40),
      letterSpacing: "0.25%",
    },
    small: {
      fontSize: rem(28),
      lineHeight: rem(36),
      letterSpacing: "0.25%",
    },
  },
  blogH1: {
    large: {
      fontSize: rem(38),
      lineHeight: rem(48),
      letterSpacing: "-0.26%",
    },
    medium: {
      fontSize: rem(29),
      lineHeight: rem(36),
      letterSpacing: "0.59%",
    },
    small: {
      fontSize: rem(25),
      lineHeight: rem(32),
      letterSpacing: "0.64%",
    },
  },
  blogH2: {
    large: {
      fontSize: rem(32),
      lineHeight: rem(40),
      letterSpacing: "0.25%",
    },
    medium: {
      fontSize: rem(25),
      lineHeight: rem(32),
      letterSpacing: "1.16%",
    },
    small: {
      fontSize: rem(22),
      lineHeight: rem(28),
      letterSpacing: "1.14%",
    },
  },
  blogH3: {
    large: {
      fontSize: rem(27),
      lineHeight: rem(36),
      letterSpacing: "0.85%",
    },
    medium: {
      fontSize: rem(23),
      lineHeight: rem(32),
      letterSpacing: "1.52%",
    },
    small: {
      fontSize: rem(20),
      lineHeight: rem(28),
      letterSpacing: "1.55%",
    },
  },
  blogCaption: {
    large: {
      fontSize: rem(18),
      lineHeight: rem(26),
    },
    small: {
      fontSize: rem(16),
      lineHeight: rem(24),
      letterSpacing: "0.25%",
    },
  },
} as const

export const uiFontSize = {
  hero1: {
    fontSize: rem(70),
    lineHeight: rem(70),
    letterSpacing: "-2px",
    textWrap: "balance",
  },
  hero2: {
    fontSize: rem(50),
    lineHeight: rem(50),
    letterSpacing: "-1px",
    textWrap: "balance",
  },
  hero3: {
    fontSize: rem(40),
    lineHeight: rem(40),
    letterSpacing: "-1px",
    textWrap: "balance",
  },
  h1: {
    fontSize: rem(32),
    lineHeight: rem(36),
    letterSpacing: "-1px",
    textWrap: "balance",
  },
  h2: {
    fontSize: rem(26),
    lineHeight: rem(28),
    letterSpacing: "-0.5px",
    textWrap: "balance",
  },
  h3: {
    fontSize: rem(22),
    lineHeight: rem(24),
    letterSpacing: "-0.5px",
    textWrap: "balance",
  },
  readable: {
    fontSize: rem(19),
    lineHeight: rem(30),
    textWrap: "pretty",
  },
  l: {
    fontSize: rem(18),
    lineHeight: rem(26),
  },
  m: {
    fontSize: rem(16),
    lineHeight: rem(24),
  },
  s: {
    fontSize: rem(14),
    lineHeight: rem(20),
  },
  xs: {
    fontSize: rem(12),
    lineHeight: rem(16),
  },
} as const

export const fontSize = {
  ...blogFontSize,
  ...uiFontSize,
} as const

export type UIFontSize = keyof typeof uiFontSize
export type BlogFontSize = keyof typeof blogFontSize
export type FontSize = keyof typeof fontSize
